export const defaultMapView = {
	center: {
		lat: 45,
		lon: 10
	},
	boxRange: 10000000,
	tilt: 0,
	roll: 0,
	heading: 0
};

export const numberOfLevels = 18;
export const zoomCoefficient = 500;

export const vectorLayerDefaultFeatureStyle = {
	fillColor: null,
	fillOpacity: 0,
	strokeColor: "#ffffff",
	strokeWidth: 2,
};

export const vectorLayerHighlightedFeatureStyle = {
	strokeColor: "#ff7a00",
	fillColor: "#ff7a00",
    fillOpacity: .25,
	strokeWidth: 4,
};